import * as types from '../actionTypes';

// Estado da feature de Link de Pagamento ao cliente final (Fase 1).
// links        -> lista de links (para rastreio nas reservas / admin)
// selectedLink -> link aberto na página pública (/pagamento/:token)
// loading      -> flag de carregamento
const initialState = {
	links: [],
	selectedLink: null,
	loading: false
};

export const paymentLinkReducer = (state = initialState, action) => {

	switch (action.type) {
		case types.SET_PAYMENT_LINKS:
			return { ...state, links: action.payload };
		case types.SET_SELECTED_PAYMENT_LINK:
			return { ...state, selectedLink: action.payload };
		case types.SET_PAYMENT_LINK_LOADING:
			return { ...state, loading: action.payload };
		default:
			return state;
	}

};
